import { useContext } from "react"
import Signature from "../../Signature/Signature"
import UserContext from "../../../services/Context/UserContext"

export default function PiSign({id}){

    const {user} = useContext(UserContext)

    return <>

        <Signature 
            data={{
                title: "Attestation de Participation sur l'Honneur",
                document: "pi",
                reference: id,
                name: user.name,
                email: user.email,
                phone: user.phone
            }}
        />

    </>
    
}